import { combineReducers } from 'redux'
import {
  SCHEDULE_ADD_ERROR, SCHEDULE_ADD_LOADING, SCHEDULE_ADD_SUCCESS,
  SCHEDULE_PAGE_ERROR, SCHEDULE_PAGE_LOADING, SCHEDULE_PAGE_SUCCESS,
  SCHEDULE_LIST_SUCCESS,
  SCHEDULE_VIEW_ERROR, SCHEDULE_VIEW_LOADING, SCHEDULE_VIEW_SUCCESS,
  SCHEDULE_UPDATE_ERROR, SCHEDULE_UPDATE_LOADING, SCHEDULE_UPDATE_SUCCESS,
  SCHEDULE_UPDATE_QUOTA_ERROR, SCHEDULE_UPDATE_QUOTA_LOADING, SCHEDULE_UPDATE_QUOTA_SUCCESS,
  SCHEDULE_DELETE_ERROR, SCHEDULE_DELETE_LOADING, SCHEDULE_DELETE_SUCCESS,
  SCHEDULE_UPDATE_ACTUAL_ERROR, SCHEDULE_UPDATE_ACTUAL_LOADING, SCHEDULE_UPDATE_ACTUAL_SUCCESS,
  SCHEDULE_VALIDATION_QUOTA_ERROR, SCHEDULE_VALIDATION_QUOTA_LOADING, SCHEDULE_VALIDATION_QUOTA_SUCCESS
} from './constant'

const scheduleAddError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_ERROR:
      return action.scheduleAddError
    default:
      return state
  }
}

const scheduleAddLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_LOADING:
      return action.scheduleAddLoading
    default:
      return state
  }
}

const scheduleAddSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_ADD_SUCCESS:
      return action.scheduleAddSuccess
    default:
      return state
  }
}

const schedulePageError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_PAGE_ERROR:
      return action.schedulePageError
    default:
      return state
  }
}

const schedulePageLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_PAGE_LOADING:
      return action.schedulePageLoading
    default:
      return state
  }
}

const schedulePageSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_PAGE_SUCCESS:
      return action.schedulePageSuccess
    default:
      return state
  }
}

const schedules = (state = [], action) => {
  switch (action.type) {
    case SCHEDULE_PAGE_SUCCESS:
      return action.schedules
    case SCHEDULE_LIST_SUCCESS:
      return action.schedules
    default:
      return state
  }
}

const scheduleViewError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_ERROR:
      return action.scheduleViewError
    default:
      return state
  }
}

const scheduleViewLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_LOADING:
      return action.scheduleViewLoading
    default:
      return state
  }
}

const scheduleViewSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_SUCCESS:
      return action.scheduleViewSuccess
    default:
      return state
  }
}

const schedule = (state = [], action) => {
  switch (action.type) {
    case SCHEDULE_VIEW_SUCCESS:
      return action.schedule
    default:
      return state
  }
}

const scheduleUpdateError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_ERROR:
      return action.scheduleUpdateError
    default:
      return state
  }
}

const scheduleUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_LOADING:
      return action.scheduleUpdateLoading
    default:
      return state
  }
}

const scheduleUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_SUCCESS:
      return action.scheduleUpdateSuccess
    default:
      return state
  }
}

const scheduleUpdateQuotaError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_QUOTA_ERROR:
      return action.scheduleUpdateQuotaError
    default:
      return state
  }
}

const scheduleUpdateQuotaLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_QUOTA_LOADING:
      return action.scheduleUpdateQuotaLoading
    default:
      return state
  }
}

const scheduleUpdateQuotaSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_QUOTA_SUCCESS:
      return action.scheduleUpdateQuotaSuccess
    default:
      return state
  }
}

const scheduleDeleteError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_ERROR:
      return action.scheduleDeleteError
    default:
      return state
  }
}

const scheduleDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_LOADING:
      return action.scheduleDeleteLoading
    default:
      return state
  }
}

const scheduleDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_DELETE_SUCCESS:
      return action.scheduleDeleteSuccess
    default:
      return state
  }
}


const scheduleUpdateActualError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_ACTUAL_ERROR:
      return action.scheduleUpdateActualError
    default:
      return state
  }
}

const scheduleUpdateActualLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_ACTUAL_LOADING:
      return action.scheduleUpdateActualLoading
    default:
      return state
  }
}

const scheduleUpdateActualSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_UPDATE_ACTUAL_SUCCESS:
      return action.scheduleUpdateActualSuccess
    default:
      return state
  }
}

const scheduleValidationError = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VALIDATION_QUOTA_ERROR:
      return action.scheduleValidationError
    default:
      return state
  }
}

const scheduleValidationLoading = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VALIDATION_QUOTA_LOADING:
      return action.scheduleValidationLoading
    default:
      return state
  }
}

const scheduleValidationSuccess = (state = false, action) => {
  switch (action.type) {
    case SCHEDULE_VALIDATION_QUOTA_SUCCESS:
      return action.scheduleValidationSuccess
    default:
      return state
  }
}

const scheduleReducer = combineReducers({
  scheduleAddError,
  scheduleAddLoading,
  scheduleAddSuccess,

  schedulePageError,
  schedulePageLoading,
  schedulePageSuccess,

  scheduleViewError,
  scheduleViewLoading,
  scheduleViewSuccess,

  scheduleUpdateError,
  scheduleUpdateLoading,
  scheduleUpdateSuccess,

  scheduleUpdateQuotaError,
  scheduleUpdateQuotaLoading,
  scheduleUpdateQuotaSuccess,

  scheduleDeleteError,
  scheduleDeleteLoading,
  scheduleDeleteSuccess,

  scheduleUpdateActualError,
  scheduleUpdateActualLoading,
  scheduleUpdateActualSuccess,

  schedules,
  schedule,

  scheduleValidationError,
  scheduleValidationLoading,
  scheduleValidationSuccess,
})

export default scheduleReducer
